import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { firstValueFrom, lastValueFrom, Observable } from 'rxjs';
import { IPagedStripeTransactionResultRequestDto } from 'src/app/models/backend/stripeTransactions';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private stripe: Stripe | null = null;
   readonly url = environment.apiUrl+'StripeTransactions/';


  Token = localStorage.getItem("Token")
  headers = new HttpHeaders()
    .set('Content-Type', 'application/json; charset=utf-8')
    .set('Authorization', `Bearer ${this.Token}`);
  constructor(private http: HttpClient) {}

  async initializeStripe(): Promise<void> {
    console.log("Stripe initialized");
    if (!this.stripe) {

       const val:any=await lastValueFrom(this.http.post(this.url+'GetPublicKey',null,{headers:this.headers}));
       this.stripe = await loadStripe(val.publishableKey);
      // this.http.post(this.url+'GetPublicKey',null,{headers:this.headers}).subscribe({
      //   next:(val:any)=>{
      //     console.log(val);
      //     this.stripe = await loadStripe(val);
      //   },error:(err)=>{
      //     console.log('error loading stripe');
      //   }
      // })
    }
  }

  createPaymentIntent(amount: number) {
    
   
    return this.http.post<any>(this.url+'CreatePaymentIntent', {amount },
      { headers: this.headers }
    );
  }

  async confirmCardPayment(clientSecret: string, cardElement: any): Promise<any> {
    if (!this.stripe) return;

    const result = await this.stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardElement,
      },
    });

    return result;
  }

  //  async createCheckoutSession(){
  //   const response=  this.http.post<any>('https://localhost:7158/api/StripeTransactions/create-checkout-session',null,
  //      {headers: this.headers,});
  //      return Promise.resolve(response);
  // }
  createCheckoutSession(amount:number): Promise<{ sessionId: string }> {
    const payLoad={
      amount: amount,
      successUrl: environment.appBaseUrl+environment.appName+'payments/success',
      cancelUrl: environment.appBaseUrl+environment.appName+'payments'
    }
    // return this.http.post<{ sessionId: string }>('https://localhost:7158/api/StripeTransactions/create-checkout-session',payLoad, {
    //     headers: this.headers}).toPromise();
    return firstValueFrom(
      this.http.post<{ sessionId: string }>(
        this.url+'create-checkout-session',
        payLoad,
        { headers: this.headers }
      )
    );
  }
  async redirectToCheckout(sessionId: string) {
    if (!this.stripe) {
      throw new Error('Stripe is not initialized');
    }
    await this.stripe.redirectToCheckout({ sessionId });
  }

   logPayment(SessionId: string):Observable<any> {
    return this.http.post(this.url+'log-transaction', {
      SessionId
    },{headers:this.headers});
  }
  getAllStripeTransactions(input: IPagedStripeTransactionResultRequestDto) {
    return this.http.post(this.url+'GetAllStripeTransactions', input,{headers:this.headers});
  }
  
}